import APIService from '../api.service';

export const List = (params = {}) => {
  return APIService.get(`/v01/versions`, {
    params: {
      per_page: params.perPage || 10,
      page: params.page || 1,
      keyword: params.keyword || undefined,
    },
  });
};

export const Show = (id) => {
  return APIService.get(`/v01/versions/${id}`);
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/versions`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id, ...data } = payload;
  return APIService.put(`/v01/versions/${id}`, data, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/versions/${id}`, config);
};

const VersionService = {
  List,
  Show,
  Create,
  Put,
  Delt,
};

export default VersionService;
